export default __webpack_public_path__ + "static/clothing-v2-01-pants-waist-0a2817d0566e449b77d3ccc1b7b2d20d.png";